<template>
  <div class="d-inline-block">
    <v-btn
      small
      color="primary"
      :disabled="disabled"
      @click="openDialog"
    >
      {{ $t('license_plate_batch_input') }}
    </v-btn>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-title>{{ $t('license_plate_batch_input_title') }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="inputText"
            :label="$t('license_plate_batch_input_label')"
            :placeholder="$t('license_plate_batch_input_placeholder')"
            rows="5"
            auto-grow
            outlined
            hide-details
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">{{ $t('common_cancel') }}</v-btn>
          <v-btn color="primary" text @click="addPlates">{{ $t('common_new') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'LicensePlateBatchInputButton',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    inputText: ''
  }),
  methods: {
    openDialog () {
      this.inputText = ''
      this.dialog = true
    },
    cancel () {
      this.dialog = false
      this.inputText = ''
    },
    addPlates () {
      const normalize = (plate) => plate.toUpperCase()
      const newPlates = this.inputText
        .split(/[,，\n\r]+/)
        .map((plate) => plate.trim())
        .filter((plate) => plate.length > 0)
      const merged = Array.isArray(this.value) ? [...this.value] : []
      const normalizedMerged = merged.map(normalize)
      for (const plate of newPlates) {
        const normalized = normalize(plate)
        if (!normalizedMerged.includes(normalized)) {
          merged.push(normalized)
          normalizedMerged.push(normalized)
        }
      }
      this.$emit('input', merged)
      this.dialog = false
      this.inputText = ''
    }
  }
}
</script>
